const payoffSchema = {
  paymentAccountId: [{
    rule: 'required',
    error: 'This field is required',
  }],
};

export default payoffSchema;
